import React from 'react';

import InvestmentCardPropertyLocation from '../components/InvestmentCardPropertyLocation';

const section2FactoryFactory = (props) => {
  const { propertyLocation } = props;

  const section2Factory = () => {
    return (
      <InvestmentCardPropertyLocation
        propertyLocation={propertyLocation}
      />
    );
  };

  return section2Factory;
};

export default section2FactoryFactory;
